import React, { useEffect, useRef, useState } from 'react';
import { sopFire } from '../../../utils/sopSwal';
import StageChrome from '../components/StageChrome';
import useGameTimer from '../components/useGameTimer';
import { ASSET, reportOnSubmit, stagecheck, submitStage } from '../../../utils/sopGame';
import '../stages.css';

const ANSWERS = ['hideki tojo', 'adolf hitler'];
const IMAGES = ['s6-1.png', 's6-2.png'];

export default function Stage6({ user, onComplete, reportId, initialSeconds }) {
  const [vals, setVals] = useState(['', '']);
  const [status, setStatus] = useState(['', '']);
  const [blur, setBlur] = useState([true, true]);
  const [score, setScore] = useState(0);
  const [sending, setSending] = useState(false);
  const scored = useRef([false, false]);
  const timeeRef = useRef('00:00:00');
  const { display } = useGameTimer(initialSeconds, (hms) => {
    timeeRef.current = hms;
  });

  useEffect(() => {
    stagecheck(user).then(setScore).catch(console.error);
  }, [user]);

  const onInput = (i, val) => {
    setVals((v) => {
      const n = [...v];
      n[i] = val;
      return n;
    });
    const trimmed = val.trim().toLowerCase();
    if (!trimmed) {
      setStatus((s) => {
        const n = [...s];
        n[i] = '';
        return n;
      });
      setBlur((b) => {
        const n = [...b];
        n[i] = true;
        return n;
      });
      return;
    }
    const ok = trimmed === ANSWERS[i];
    setStatus((s) => {
      const n = [...s];
      n[i] = ok ? 'correct' : 'wrong';
      return n;
    });
    setBlur((b) => {
      const n = [...b];
      n[i] = !ok;
      return n;
    });
    if (ok && !scored.current[i]) {
      scored.current[i] = true;
      setScore((s) => s + 1);
    }
  };

  const submit = async () => {
    if (sending) return;
    if (vals.some((v) => !v.trim())) {
      sopFire({ text: 'Please fill all fields before submitting.' });
      return;
    }
    await sopFire({ text: 'Correct Answer is HIDEKI TOJO AND ADOLF HITLER' });
    let points1 = 0;
    vals.forEach((v, i) => {
      if (v.trim().toLowerCase() === ANSWERS[i]) points1 += 1;
    });
    setSending(true);
    try {
      await submitStage(user, {
        points: score,
        points1,
        round: 6,
        timee: timeeRef.current,
        reportId,
      });
      await reportOnSubmit(user, { points: score, timee: timeeRef.current, round: 6, reportId });
      await sopFire({
        text: 'The secrets dont end. But this game does, with one final stage. Proceed to play!',
      });
      onComplete();
    } catch (err) {
      console.error(err);
      sopFire({ text: err.message || 'Submit failed' });
      setSending(false);
    }
  };

  return (
    <StageChrome
      title="Identify lesser-known facts about Subhash Chandra Bose's contributions to India's struggle for independence"
      score={score}
      timerDisplay={display}
    >
      <p className="sop-subtitle">
        Bose garnered international support for India's freedom struggle. Identify these leaders
        whose efforts resulted in the formation of the Free India Center in Germany and the provision
        of military training and support to the INA.
      </p>
      <div className="sop-blur-grid">
        {IMAGES.map((img, i) => (
          <div className="sop-blur-col" key={img}>
            <img
              src={ASSET.img(img)}
              alt=""
              className={blur[i] ? 'blurred' : ''}
              id={`img${i}`}
            />
            <input
              className={`sop-input ${status[i]}`}
              value={vals[i]}
              placeholder="Type Here"
              readOnly={status[i] === 'correct'}
              onChange={(e) => onInput(i, e.target.value)}
              autoComplete="off"
            />
          </div>
        ))}
      </div>
      <div className="sop-actions">
        <button type="button" className="sop-img-btn" disabled={sending} onClick={submit}>
          <img src={ASSET.img('submit.png')} alt="Submit" />
        </button>
      </div>
    </StageChrome>
  );
}
